import { render, staticRenderFns } from "./BackBar.vue?vue&type=template&id=4de13bc8&"
import script from "./BackBar.vue?vue&type=script&lang=js&"
export * from "./BackBar.vue?vue&type=script&lang=js&"
import style0 from "./BackBar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VIcon,VSpacer})
